import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({ name: 'translateInputValue', standalone: true })
export class TranslateInputValuePipe implements PipeTransform {
  constructor(public translocoService: TranslocoService) {}

  transform(inputObject: any, inputKey: string) {
    const lang = this.translocoService.getActiveLang();

    // for example: object.translations.name.sv
    const translation = inputObject?.translations?.[inputKey]?.[lang];

    return translation || inputObject?.[inputKey];
  }
}
